import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSegment, ActivatedRoute, Route, UrlSegmentGroup } from '@angular/router';
import { BrowserSupportMessageComponent } from './components/browser-support-message/browser-support-message.component';
import { LoginViaOtpComponent } from './components/login-via-otp/login-via-otp.component';
import { LoginViaPasswordComponent } from './components/login-via-password/login-via-password.component';
import { LoginViaOtpMoeComponent } from './components/login-via-otp-moe/login-via-otp-moe.component';
import { AuthenticationGuard } from './core/authentication/authentication.guard';
import { LoginCombinedEduGovComponent } from './page/login-combined-edu-gov/login-combined-edu-gov.component';
import { LoginComponent } from './page/login/login.component';
import { LoginViaSMSComponent } from './components/login-via-sms/login-via-sms.component';
import { LoginViaPasswordMoeComponent } from './components/login-via-password-moe/login-via-password-moe.component';
import { GeneralErrorComponent } from './components/general-error/general-error.component';
import { UserLockedComponent } from './components/user-locked/user-locked.component';




const routes: Routes = [
  { path: '', component: GeneralErrorComponent, pathMatch: 'full' },
  //{ path: '', component: BrowserSupportMessageComponent, pathMatch: 'full' },
  { path: 'login', component: LoginCombinedEduGovComponent, pathMatch: 'full' },
  { path: 'loginWithIdAndMobile', component: LoginComponent, pathMatch: 'full' },
  { path: 'codeOtp', component: LoginViaOtpComponent, pathMatch: 'full' },
  { path: 'browserSupport', component: BrowserSupportMessageComponent, pathMatch: 'full' },
  { path: 'loginOtpOnly', component: LoginViaSMSComponent, pathMatch: 'full' },
  { path: 'loginOtpOnlyOtp', component: LoginViaOtpComponent, pathMatch: 'full' },
  { path: 'loginPasswordMoe', component: LoginViaPasswordMoeComponent, pathMatch: 'full' },
  { path: 'loginViaPassword', component: LoginViaPasswordComponent, pathMatch: 'full' },
  { path: 'loginOtpMoe', component: LoginViaOtpMoeComponent, pathMatch: 'full' },
  { path: 'GeneralError', component: GeneralErrorComponent, pathMatch: 'full' },
  { path: 'locked', component: UserLockedComponent, pathMatch: 'full' },
  { path: '**', component: GeneralErrorComponent }
  //{ path: '**', component: BrowserSupportMessageComponent }

];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
